import GlowButton from '@/components/base/GlowButton';

interface AdBannerProps {
  variant?: 'inline' | 'bottom';
}

const inlineAds = [
  {
    image: 'https://readdy.ai/api/search-image?query=telegram%20premium%20subscription%20advertisement%20banner%20light%20white%20background%20with%20blue%20telegram%20logo%20and%20premium%20features%20showcase%20clean%20minimal&width=800&height=160&seq=201&orientation=landscape',
    title: 'Telegram Premium',
    desc: 'Unlock exclusive features — faster downloads, unique stickers, and more.',
    cta: 'Try Premium',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=crypto%20exchange%20platform%20advertisement%20banner%20light%20background%20with%20bitcoin%20ethereum%20coins%20and%20trading%20interface%20clean%20minimal%20design&width=800&height=160&seq=202&orientation=landscape',
    title: 'CryptoExchange Pro',
    desc: 'Trade 500+ cryptocurrencies with zero fees for the first month.',
    cta: 'Start Trading',
  },
];

let adIndex = 0;

export default function AdBanner({ variant = 'inline' }: AdBannerProps) {
  const ad = inlineAds[adIndex++ % inlineAds.length];

  if (variant === 'bottom') {
    return (
      <div className="w-full rounded-2xl border border-dashed border-[#0088CC]/25 bg-white/60 backdrop-blur-md overflow-hidden">
        <div className="flex items-center gap-2 px-4 py-2 border-b border-slate-100">
          <span className="text-[10px] font-semibold text-[#0088CC] uppercase tracking-wider">Advertisement</span>
        </div>
        {/* 移动端竖排，桌面端横排叠图 */}
        <div className="flex flex-col sm:block">
          <div className="relative w-full h-24 sm:h-32">
            <img
              src="https://readdy.ai/api/search-image?query=telegram%20community%20directory%20platform%20advertisement%20footer%20banner%20light%20white%20background%20with%20community%20icons%20and%20join%20now%20call%20to%20action%20minimal%20clean&width=1200&height=128&seq=203&orientation=landscape"
              alt="Advertisement"
              className="w-full h-full object-cover object-top"
            />
            {/* 桌面端叠加文字按钮 */}
            <div className="hidden sm:flex absolute inset-0 bg-gradient-to-r from-white/85 via-transparent to-white/85 items-center justify-between px-8">
              <div>
                <p className="text-slate-800 font-bold text-lg">Advertise Your Community</p>
                <p className="text-slate-500 text-sm">Reach 100,000+ Telegram users daily</p>
              </div>
              <GlowButton as="a" href="#contact" className="text-sm font-semibold px-5 py-2.5 rounded-full whitespace-nowrap">
                Get Started
              </GlowButton>
            </div>
          </div>
          {/* 移动端文字+按钮在图片下方 */}
          <div className="sm:hidden flex items-center justify-between px-4 py-3 gap-3">
            <div className="min-w-0">
              <p className="text-slate-800 font-bold text-sm leading-snug">Advertise Your Community</p>
              <p className="text-slate-500 text-xs mt-0.5">Reach 100,000+ Telegram users daily</p>
            </div>
            <GlowButton as="a" href="#contact" className="text-xs font-semibold px-3 py-2 rounded-full whitespace-nowrap shrink-0">
              Get Started
            </GlowButton>
          </div>
        </div>
      </div>
    );
  }

  // inline variant
  return (
    <div className="col-span-full rounded-2xl border border-dashed border-[#0088CC]/25 bg-white/60 backdrop-blur-md overflow-hidden">
      <div className="flex items-center gap-2 px-4 py-1.5 border-b border-slate-100">
        <span className="text-[10px] font-semibold text-[#0088CC] uppercase tracking-wider">Sponsored</span>
      </div>
      {/* 移动端竖排，桌面端横排叠图 */}
      <div className="flex flex-col sm:block">
        <div className="relative w-full h-24 sm:h-28">
          <img src={ad.image} alt={ad.title} className="w-full h-full object-cover object-top" />
          {/* 桌面端叠加 */}
          <div className="hidden sm:flex absolute inset-0 bg-gradient-to-r from-white/90 via-white/60 to-transparent items-center px-6 gap-6">
            <div className="flex-1 min-w-0">
              <p className="text-slate-800 font-bold text-base">{ad.title}</p>
              <p className="text-slate-500 text-xs mt-0.5">{ad.desc}</p>
            </div>
            <GlowButton as="a" href="#" className="text-xs font-semibold px-4 py-2 rounded-full shrink-0 whitespace-nowrap">
              {ad.cta}
            </GlowButton>
          </div>
        </div>
        {/* 移动端文字+按钮在图片下方 */}
        <div className="sm:hidden flex items-center justify-between px-4 py-3 gap-3">
          <div className="min-w-0">
            <p className="text-slate-800 font-bold text-sm leading-snug">{ad.title}</p>
            <p className="text-slate-500 text-xs mt-0.5 line-clamp-1">{ad.desc}</p>
          </div>
          <GlowButton as="a" href="#" className="text-xs font-semibold px-3 py-2 rounded-full shrink-0 whitespace-nowrap">
            {ad.cta}
          </GlowButton>
        </div>
      </div>
    </div>
  );
}
